import React, { useState, useId } from 'react';
import styles from './SearchInput.module.scss';
import Label from '../../label/Label';
import searchIcon from '../../../../../assets/icons/vector/searchIcon.svg';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import { useBrandingContext } from 'app-context/BrandingsContext';
const SearchInput = ({
  label,
  placeholder = 'Search',
  name,
  value = '',
  onChange,
  onBlur,
  classname,
  style,
  disabled,
  props,
  inputClassName,
  containerClassName,
}) => {
  const id = useId();
  const { brandingData } = useBrandingContext();
  const { page_TextColor } = brandingData;
  const [initialValue, setInitialValue] = useState(value);

  const handleChange = (event) => {
    const newValue = event.target.value;
    setInitialValue(newValue);
    if (onChange) {
      onChange(name, newValue);
    }
  };

  return (
    <div
      className={`${styles['search-input-container']} ${containerClassName}`}
      style={style}
    >
      {label ? <Label text={label} htmlFor={id} /> : null}
      <div className={`${styles['input-wrapper']} ${classname ?? ''}`}>
        <SvgWithBranding type="search_input" className={styles['svg']} />
        <input
          id={id}
          name={name}
          className={`${styles.input} ${inputClassName}`}
          placeholder={placeholder}
          onChange={handleChange}
          onBlur={onBlur}
          value={initialValue}
          style={{ color: page_TextColor }}
          disabled={disabled}
          {...props}
        />
      </div>
    </div>
  );
};

export default SearchInput;
